<template>
  <div class="vx-col w-full text-center mt-5">
    <vs-spinner v-if="!errorMessage"></vs-spinner>
    <p v-else class="text-danger mt-4">{{ errorMessage }}</p>
  </div>
</template>

<script>
import StripeConnectService from '@/services/api/StripeConnectService'

// Item de menu "Painel do Stripe" (Financeiro): a aba nasce nesta rota só
// para sair direto para o dashboard Express do Stripe do estabelecimento
// ativo — não é uma tela de verdade, por isso o spinner é tudo que ela
// mostra em caso de sucesso.
export default {
  name: 'StripeDashboardRedirect',
  data() {
    return {
      errorMessage: null
    }
  },
  async mounted() {
    if (!this.$store.getters['dataAccess/loaded']) {
      await this.$store.dispatch('dataAccess/setupFromLogin')
    }

    const activeId = this.$store.getters['dataAccess/activeInstitutionId']
    const entities = this.$store.getters['dataAccess/entities'] || []
    const targetId = activeId || (entities.length === 1 ? entities[0].id : null)

    if (!targetId) {
      this.errorMessage =
        'Selecione um estabelecimento no topo da tela antes de abrir o painel do Stripe.'
      return
    }

    const service = StripeConnectService.build(this.$vs)
    try {
      const { url } = await service.getLoginLink(targetId)
      window.location.replace(url)
    } catch (error) {
      // A mensagem real (conta não pronta, falha no Stripe) já aparece via
      // interceptor global — aqui só encerra o spinner com um texto genérico.
      this.errorMessage = 'Não foi possível abrir o painel do Stripe.'
    }
  }
}
</script>
